import {memo} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {ClientReportSubmitInput} from "../domain";
import {SimpleDropdown} from "common";

type ClientReportTypeInputProps = {
    disabled: boolean;
    callback: () => void;
    clientReportTypeOptions: Map<string, string>
};
export const ClientReportTypeInput = memo(({
                                               disabled,
                                               callback,
                                               clientReportTypeOptions
                                           }: ClientReportTypeInputProps) => {
    const {
        setValue,
        clearErrors,
        control,
        formState: {
            errors
        },
    } = useFormContext<ClientReportSubmitInput>();

    return (
        <div>
            <div className="flex text-black-200 pb-2 items-center text-base">
                <div className="w-2/6 text-right">
                    Report Type
                </div>
                <div className="ml-4 flex items-center">
                    <Controller
                        name="reportType"
                        control={control}
                        rules={{
                            required: true
                        }}
                        render={({field: {value}}) =>
                            <SimpleDropdown
                                options={clientReportTypeOptions}
                                selected={value}
                                disabled={disabled}
                                hasErrorBorder={errors.reportType !== undefined}
                                setSelected={(selected) => {
                                    setValue("reportType", selected);
                                    callback();
                                    clearErrors("reportType");
                                }}
                                textColor={"black-200"}
                            />
                        }/>
                </div>
            </div>
            {
                errors.reportType &&
                <div className="flex">
                    <div className="w-2/6"/>
                    <div className="ml-4 text-red-700">
                        Please select “Report Type” before submitting the report
                    </div>
                </div>
            }
        </div>
    );
});
